"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewerAvatar = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ViewerAvatar = function (_a) {
    var _b = _a.viewer, isAnonymous = _b.isAnonymous, firstName = _b.firstName, lastName = _b.lastName, _c = _a.size, size = _c === void 0 ? kaleidoscope_1.AvatarSize.Large : _c;
    return react_1.default.createElement(kaleidoscope_1.Avatar, __assign({ size: size }, getAvatarProps(isAnonymous, firstName, lastName)));
};
exports.ViewerAvatar = ViewerAvatar;
function getAvatarProps(isAnonymous, firstName, lastName) {
    if (isAnonymous)
        return {};
    return { firstName: firstName, lastName: lastName };
}
